export const isRequired = (value) => {
  return !!value?.toString().trim().length > 0;
};

export const isValidPassword = (value) => {
  return !!value?.toString().trim() && value.trim().length >= 6;
};

export function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email?.toString().trim());
}

export function isValidSubdomain(subdomain) {
  /*
    Explanation:
    ^                      // Start of string.
    (?=.{1,63}$)          // Lookahead: Ensures the entire string is between 1 and 63 characters.
    (?!-)                 // Negative lookahead: Ensures the string does not start with a hyphen.
    [A-Za-z0-9-]+         // Matches one or more letters (A-Z, a-z), digits (0-9), or hyphens.
    (?<!-)                // Negative lookbehind: Ensures the string does not end with a hyphen.
    $                      // End of string.
  */
  const subdomainRegex = /^(?=.{1,63}$)(?!-)[A-Za-z0-9-]+(?<!-)$/;
  return subdomainRegex.test(subdomain);
}

export function isValidWorkspaceName(name) {
  return name.trim().length > 0;
}

export function isValidFullName(name) {
  if (!name) {
    return false;
  }

  // Require >= 3 characters and <= 100 characters
  const trimmedName = name.trim();
  if (trimmedName.length < 3 || trimmedName.length > 100) {
    return false;
  }

  // Split into parts and require >= 2 parts
  const nameParts = trimmedName.split(/\s+/);
  if (nameParts.length < 2) {
    return false;
  }

  // Letters (including accents), apostrophes, hyphens, and periods
  const namePart = /^[\p{L}’'.-]+$/u;
  return nameParts.every(part => namePart.test(part));
}

export function isValidPhoneNumber(phoneNumber) {
  if (!phoneNumber) {
    return false;
  }

  const trimmed = phoneNumber.toString().trim();
  // Basic phone number validation: 10+ digits with optional formatting
  const phoneRegex = /^[\+]?[\s().-]*([0-9][\s().-]*){10,}$/;
  return phoneRegex.test(trimmed);
}

export function isValidUrl(url) {
  if (!url) {
    return false;
  }

  const trimmed = url.toString().trim();
  if (!trimmed) {
    return false;
  }

  const urlWithProtocol = /^https?:\/\//i.test(trimmed)
    ? trimmed
    : `https://${trimmed}`;

  try {
    const parsed = new URL(urlWithProtocol);

    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
      return false;
    }
    // Ensure hostname has a TLD (e.g., .com, .org)
    return /\.[a-z]{2,}$/i.test(parsed.hostname);
  } catch {
    return false;
  }
}